import { isIframed } from './iframe'

function scrollIntoViewUnlessIframe (element, options = {}) {
  if (isIframed()) return

  element.scrollIntoView(options)
}

export { scrollIntoViewUnlessIframe }
